module.exports = __webpack_public_path__ + "static/img/solve5.aadf23ff.png";